import React from 'react';

export enum SidebarType {
  ProductForm = 'ProductForm',
  SupplierForm = 'SupplierForm',
  CustomerForm = 'CustomerForm',
}

const SidebarContext = React.createContext({ modal: false } as SidebarContextType);
export default SidebarContext;

export type SidebarContextType = {
  openSidebar?: (type: SidebarType, entityId: number) => void;
  closeSidebar?: () => void;
  modal: boolean;
};
